<template>

  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="wizard-perfil"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de la empresa
                  </h3>
                  <div class="wizard-desc">
                    Empresa asociada a la cuenta
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wizard-step"
              data-wizard-type="step"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información del Usuario
                  </h3>
                  <div class="wizard-desc">
                    Configure datos personales
                  </div>
                </div>
              </div>
            </div>

            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/svg/icons/Map/Compass.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Información de Seguridad
                  </h3>
                  <div class="wizard-desc">
                    Configure credenciales
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <b-form class="form" @submit.stop.prevent="onSubmit">
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Información de la empresa Asociada
                  </h4>
                  <div class="form-group">
                      <div class="form-group">
                        <label>Empresa</label>
                      {{user.nombreEmpresa}}
                      </div>
                    </div>
                    <button
                      class="btn btn-primary align-self-center"
                      data-wizard-type="action-next"
                    >
                      Continuar
                    </button>
                </div>
                <!--end: Wizard Step 1-->
                <!--begin: Wizard Step 2-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Ingrese los datos personales
                  </h4>
                  <InformacionPersonal
                    :user="user"
                  ></InformacionPersonal>
                   
                </div>
                <!--end: Wizard Step 2-->

                <!--begin: Wizard Step 3-->
                <div class="pb-5" data-wizard-type="step-content">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    Configure Información de Acceso
                  </h4>
                  <CambiarContrasena  :user="user"></CambiarContrasena>
                </div>
                <!--end: Wizard Step 3-->

                

               
              </b-form>
            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>

</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>
<style>
.transparent {
  background: transparent !important;
}
.perfil-menu {
  background: #fff;
}
.perfil-body {
  background: #fff;
}
</style>
<script>
import { mapState } from "vuex";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import InformacionPersonal from "@/view/pages/profile/InformacionPersonal";
import CambiarContrasena from "@/view/pages/profile/CambiarContrasena";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
export default {
  name: "perfilUsuario",
  components: {
    InformacionPersonal,
    CambiarContrasena
  },
  data() {
    return {
      form: {
        email: "",
        contrasena: "",
        rutUsuario: "",
        rutUsuarioDv: "",
        nombre: "",
        apellidoPaterno: "",
        celular: "",
        confirmarContrasena: ""
      },
      datosUsuario: { loaded: false }
    };
  },
  methods: {
    
  },
  mounted() {
    // Initialize form wizard
    const wizard = new KTWizard("wizard-perfil", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on("change", wizardObj => {
      switch (wizardObj.currentStep) {
        case 1:
          //this.obtenerUsuario();
          break;
        case 2:
          //this.obtenerUsuario();
          break;
      }
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      user: state => state.auth.user,
    })
  }
};
</script>